export const dispatchBasketUpdatedEvent = () => {
  const event = new Event('basketUpdated');
  document.dispatchEvent(event);
};
